import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesForeignTradeTextWrapper = _resolveComponent("AnalyticsNotesForeignTradeTextWrapper")!

  return (_ctx.getForeignTradeTemplateData)
    ? (_openBlock(), _createBlock(_component_AnalyticsNotesForeignTradeTextWrapper, {
        key: 0,
        isLoading: _ctx.isTemplateDataLoading,
        isInitLoadedData: _ctx.isInitLoadedData
      }, {
        "paragraph-0": _withCtx(() => [
          _createTextVNode(" Внешнеторговый оборот России с " + _toDisplayString(_ctx.countryNameInstrumental) + " в " + _toDisplayString(_ctx.formatDisplayNumber(_ctx.getForeignTradeTemplateData.endPeriodYear)) + " г., по данным российской таможенной статистики, " + _toDisplayString(_ctx.getTotalTradeSummaryText) + ", в том числе экспорт " + _toDisplayString(_ctx.getExportSummaryText) + ", а импорт " + _toDisplayString(_ctx.getImportSummaryText) + ". ", 1)
        ]),
        "paragraph-1": _withCtx(() => [
          _createTextVNode(" Данные за исключением продукции ТЭК (27 тов.гр.) составили: " + _toDisplayString(_ctx.getWithoutTekTotalTradeSummaryText) + ", " + _toDisplayString(_ctx.getWithoutTekExportSummaryText) + ", " + _toDisplayString(_ctx.getBalanceSummaryText), 1)
        ]),
        _: 1
      }, 8, ["isLoading", "isInitLoadedData"]))
    : _createCommentVNode("", true)
}